import { firebaseAuth, googleProvider } from "../../config/constants";
import { store } from "../../reducers";
import * as AuthActions from './actions'

export const signInWithGoogle = () => {
	firebaseAuth.signInWithPopup( googleProvider ).then((response) => {
		if ( response.error ) {
			throw new Error( 'Unable to login with Google' );
		}
	})
};

export const signOutUser = () => {
	firebaseAuth.signOut().then( () => {
		store.dispatch( AuthActions.dropUserState() );
	});
};

firebaseAuth.onAuthStateChanged(user => {
	if ( user && -1 !== user.email.indexOf( '@frankwatching.com' ) ) {
		store.dispatch( AuthActions.setUserState(user));
	} else if ( user && ! user.email.indexOf( '@frankwatching.com' ) ) {
		user.delete().then( () => {
			store.dispatch( AuthActions.dropUserState() );
		})
	} else {
		store.dispatch( AuthActions.dropUserState() );
	}
});


// WEBPACK FOOTER //
// ./src/api/auth/index.js